import { map, switchMap, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { Injectable } from '@angular/core';

import { Select, Store } from '@ngxs/store';

import { UserState } from '@app/core/store/states/user/user.state';
import { SetUserTableSettings } from '@app/core/store/states/user/user-state.actions';
import { TableLayout, TableLayoutId } from '../models/table-layout.model';
import { UserSetting, UserTableLayoutSettings } from '@app/core/models/user.models';

@Injectable({
  providedIn: 'root',
})
export class TableLayoutRepositoryService {
  @Select(UserState.setting(UserSetting.TableLayout))
  readonly tableLayout$!: Observable<UserTableLayoutSettings>;

  @Select(UserState.userId)
  readonly userId$!: Observable<number>;

  getTableLayout(layoutId: TableLayoutId): Observable<TableLayout> {
    return this.assertLocaleStorageMigration().pipe(
      switchMap(() => this.tableLayout$.pipe(map((layout) => layout?.[layoutId]))),
    );
  }

  setTableLayout(layoutId: TableLayoutId, layout: TableLayout): Observable<unknown> {
    return this.store.dispatch(new SetUserTableSettings({ [layoutId]: layout }));
  }

  removeTableLayout(layoutId: TableLayoutId): Observable<unknown> {
    return this.store.dispatch(new SetUserTableSettings({ [layoutId]: null }));
  }

  constructor(private store: Store) {}

  private assertLocaleStorageMigration(): Observable<void> {
    return this.userId$.pipe(
      take(1),
      map((userId) => `adspert.${userId}.layout.table`),
      switchMap((key) => {
        const layout = JSON.parse(localStorage.getItem(key)) as UserTableLayoutSettings;

        if (layout) {
          localStorage.removeItem(key);
          return this.store.dispatch(new SetUserTableSettings(layout));
        } else {
          return of(void 0);
        }
      }),
    );
  }
}
